var cookiePopup = document.querySelector('.cookie');
if (cookiePopup) {
  if (!getCookie('cookieSaveAllowed')) {
    cookiePopup.style.display = '-webkit-box';
    var button = cookiePopup.getElementsByClassName('cookie__block-button');
    if (button.length > 0) {
      button[0].addEventListener('click', function (e) {
        createCookie('cookieSaveAllowed', true, 7);
        cookiePopup.style.display = 'none';
      });
    }
  }
}

function getCookie(name) {
  var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function createCookie(name, value, days) {
  var expires;
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toGMTString();
  }
  else {
    expires = '';
  }
  document.cookie = name + '=' + value + expires + '; path=/';
}